import { Component, OnInit } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationEnd } from '@angular/router';
import * as NProgress from 'nprogress';
import { CommonService } from './common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public authenticated = false;

  pagesComponentRoute = false;
  commonService;

  constructor(private router: Router, private cs: CommonService) {
    this.commonService = cs;
    NProgress.configure({ showSpinner: false });
  }

  ngOnInit() {
    this.router.events.subscribe((obj: any) => {
      this.pagesComponentRoute = (!!obj.url && obj.url.includes('/pages')) ? true : false;
      if (obj instanceof RouteConfigLoadStart) {
        NProgress.start();
        NProgress.set(0.4);
      } else if (obj instanceof RouteConfigLoadEnd) {
        NProgress.set(0.9);
        setTimeout(() => {
          NProgress.done();
          NProgress.remove();
        }, 500);
      } else if (obj instanceof NavigationEnd) {
        this.cs.navbarToggleValue = false;
        this.cs.sidebarToggleValue = true;
        window.scrollTo(0, 0);
      }
    });
  }

}
